import { Collapse, CollapseProps, styled } from '@mui/material';

interface PropTypes extends CollapseProps{
    expanded: boolean;
}

const StyledCollapse = styled(Collapse)(() => ({
    width: '100%',
}));

export const Collapsable = (props: PropTypes): JSX.Element => {
    const {
        children,
        expanded,
        ...rest
    } = props;

    return (
        <StyledCollapse
            unmountOnExit
            in={expanded}
            timeout="auto"
            {...rest}
        >
            {children}
        </StyledCollapse>
    );
};
